var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHendiExterior(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient6292",
    id: "linearGradient6312",
    x1: 185.06396,
    y1: 307.84872,
    x2: 185.30064,
    y2: 271.59473,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    gradientTransform: "translate(80.653335 -.84651185)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6292"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fd5",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop6288"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff0b0b",
      stopOpacity: 0.79874212
    },
    offset: 0.34793249,
    id: "stop6290"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient31314-2",
    id: "linearGradient30439",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.77838 0 0 1.61031 -81.05124 -244.30511)",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient31314-2"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b3b3b3",
      stopOpacity: 1
    },
    offset: 0.07717042,
    id: "stop31302-3"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d2d2d2",
      stopOpacity: 1
    },
    offset: 0.24919616,
    id: "stop31304-6"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9c9c9c",
      stopOpacity: 1
    },
    offset: 0.40956593,
    id: "stop31306-5"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#afafaf",
      stopOpacity: 1
    },
    offset: 0.61816716,
    id: "stop31308-58"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d0d0d0",
      stopOpacity: 1
    },
    offset: 0.77893889,
    id: "stop31310-1"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#989898",
      stopOpacity: 1
    },
    offset: 0.95498395,
    id: "stop31312-4"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient31314-2",
    id: "linearGradient31318-32",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.24165 0 0 .2235 -151.59035 33.816425)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient29442",
    id: "linearGradient29444",
    x1: 40.405777,
    y1: 21.268559,
    x2: 73.111427,
    y2: 22.554464,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient29442"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#bdbdbd",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop29438"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a8a8",
      stopOpacity: 1
    },
    offset: 0.2,
    id: "stop29446"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8c8c8c",
      stopOpacity: 1
    },
    offset: 0.39951771,
    id: "stop29448"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5b5b5b",
      stopOpacity: 1
    },
    offset: 0.60490352,
    id: "stop29450"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#606060",
      stopOpacity: 1
    },
    offset: 0.79923636,
    id: "stop29452"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "silver",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop29440"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient28700",
    id: "linearGradient28702",
    x1: 26.192024,
    y1: 39.753902,
    x2: 51.866421,
    y2: 55.489822,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient28700"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c9634e",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop28696"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f14a2c",
      stopOpacity: 1
    },
    offset: 0.2,
    id: "stop28704"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e34424",
      stopOpacity: 1
    },
    offset: 0.40000001,
    id: "stop28706"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ef4f32",
      stopOpacity: 0.98113215
    },
    offset: 0.60000002,
    id: "stop28708"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f68a74",
      stopOpacity: 1
    },
    offset: 0.79923636,
    id: "stop28710"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff2525",
      stopOpacity: 0.93081754
    },
    offset: 1,
    id: "stop28698"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient29458",
    id: "linearGradient29460",
    x1: 27.744911,
    y1: 40.582108,
    x2: 50.417057,
    y2: 55.282772,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient29458"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#acacac",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop29454"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#626262",
      stopOpacity: 1
    },
    offset: 0.20096463,
    id: "stop29462"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#575757",
      stopOpacity: 1
    },
    offset: 0.40000001,
    id: "stop29464"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#676767",
      stopOpacity: 1
    },
    offset: 0.60490352,
    id: "stop29466"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b0b0",
      stopOpacity: 1
    },
    offset: 0.79923636,
    id: "stop29468"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#adadad",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop29456"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient29474",
    id: "linearGradient29476",
    x1: 39.132748,
    y1: 42.031471,
    x2: 38.718643,
    y2: 54.55809,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient29474"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#929292",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop29470"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9a9a",
      stopOpacity: 1
    },
    offset: 0.20418006,
    id: "stop29478"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848484",
      stopOpacity: 1
    },
    offset: 0.39951769,
    id: "stop29480"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#727272",
      stopOpacity: 1
    },
    offset: 0.60168809,
    id: "stop29482"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#606060",
      stopOpacity: 1
    },
    offset: 0.79602093,
    id: "stop29484"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2b2b2b",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop29472"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hendi",
    transform: "translate(-9.9999997 -9.9999995)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#ccc"
    },
    d: "M144.64227 302.20548h-1.52916c-.38902 0-.59649 0-1.55616.10369s-2.67133.31116-4.48698.82981c-1.81565.51865-3.73479 1.34855-5.08375 2.64565-1.34895 1.29709-2.12698 3.06062-2.74939 5.13558-.62242 2.07496-1.08923 4.4609-1.29663 7.9882-.2074 3.52729-.15553 8.19546.15592 11.25588.31146 3.06041.88201 4.51273 3.6833 5.34206 2.80129.82933 7.83255 1.03681 24.79417 1.1924 16.96161.15559 45.85239.25932 60.32403.31119 14.47162.0519 14.52346.0519 14.54889 1.73816.0254 1.6863.0254 5.05775.0513 6.63962.0258 1.58187.0777 1.3744-15.58664 1.37405-15.66434-.00036-47.0448.20712-63.61706.10351-16.57227-.1036-18.33579-.51855-20.12533-.88168-1.78953-.36313-3.60493-.67434-5.57603-1.76325-1.9711-1.08891-4.09772-2.95618-5.47271-5.93862-1.375-2.98244-1.99742-7.08005-2.33465-10.84068-.33723-3.76064-.3891-7.18396-.2854-10.89271.10371-3.70875.36305-7.70263 1.40048-10.65966 1.03743-2.95704 2.85282-4.87617 4.43495-6.35453 1.58211-1.47836 2.93069-2.51573 4.56476-3.47538 1.63406-.95964 3.5532-1.84141 5.47259-2.41193 1.91939-.57052 3.83854-.82987 5.57626-.95948 1.73772-.12962 3.29377-.12962 4.84886-.12962",
    id: "tube3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tube2",
    style: {
      display: "inline",
      fill: "#ccc"
    },
    d: "M280.05581 287.64577c-2.69323.0178-5.5951.23648-8.40234.57617-3.74302.45292-7.31855 1.12097-10.29884 2.16992-2.98029 1.04896-5.36437 2.47921-7.3672 4.50586-2.00282 2.02665-3.62371 4.64898-4.625 6.91406-1.00129 2.26509-1.38275 4.17125-1.62109 6.7461-.23834 2.57483-.3332 5.8167-.38086 9.03515-.0477 3.21846-.0483 6.41341-.0723 8.08203-.0239 1.66864-.0705 1.812 1.52735 1.85938 1.59786.0474 4.8382.00035 6.43554-.0234 1.59736-.0238 1.55015-.0235 1.50197-2.47851-.0482-2.45503-.0958-7.36621.26171-11.22852s1.12168-6.67556 2.12305-8.75 2.24002-3.40908 3.74219-4.50586c1.50216-1.09678 3.26591-1.95673 4.74414-2.55273 1.47823-.59601 2.67036-.9285 4.60157-1.11914 1.93122-.19064 4.60122-.23789 6.00781-.26172 1.40661-.0238 1.55028-.0243 2.50391.0234.95363.0477 2.71806.14185 4.72071.52344 2.00266.38159 4.24271 1.05008 5.72071 1.76563 1.47799.71554 2.19442 1.47896 3.05273 2.26562.85832.78666 1.85814 1.59593 2.5254 2.38281.66725.7869 1.00135 1.55012 1.16797 2.28907.16662.73894.16602 1.45376.16602 2.16797l.78711.0801h.36914c.17613-.005.35124-.0155.52734-.0215.15119-.005.30186-.008.45313-.01.1112-.001.22274-.002.33398-.002.11122-.00023.22276.00005.33398 0 .10565-.00003.21076 0 .31641 0 .12184-.00001.24339 0 .36523 0h.77735c.12105-.003.24262.008.36328.0156.10877.007.21718.01.32617.0117.11193.002.22399.004.33594.004.14737.00038.29406-.00009.4414 0 .11272.00006.22519-.00001.3379 0 .10338.001.20752-.0106.31054-.0176.12217-.008.24483-.0126.36719-.01.13697.0109.27329.0289.41016.041.10501.008.20918.0126.31445.0156.11819.002.23726.004.35547.004.11926.004.23746-.0152.35547-.0293.0922-.009.18368-.0183.27539-.0273.0284-1.4481-.003-2.89895-.44531-4.36718-.52411-1.74025-1.62038-3.50435-3.28907-5.55469-1.66869-2.05034-3.91043-4.38725-5.86523-5.96094-1.95481-1.57369-3.62424-2.38463-5.86525-3.07617-2.241-.69155-5.05247-1.26266-8.41407-1.42969-.8404-.0418-1.71554-.0587-2.61328-.0527zm21.69924 20.75976.21484.0215c.007-.005.0216-.004.0352 0 .0889-.004.17906-.007.26758-.0156.0196-.002.039-.004.0586-.006h-.33203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#ccc"
    },
    d: "M273.69929 336.88825c17.89237-.0461 35.78374-.0922 45.76679-.4151 9.98306-.32289 12.05804-.92233 13.80995-2.0289 1.7519-1.10658 3.18134-2.72045 4.91056-4.65717 1.72921-1.93672 3.75809-4.19615 6.50196-6.34048 2.74386-2.14434 6.20218-4.17322 10.72142-5.71795 4.51924-1.54474 10.09866-2.60529 15.12496-3.27387 5.0263-.66858 9.49906-.94524 15.05562-1.15273 5.55657-.20749 12.19653-.34582 18.14502-.39191 5.94848-.0461 11.20512.00001 15.19389.27679 3.98876.27677 6.7093.78399 9.19939 1.56808 2.49009.78409 4.74952 1.84464 6.77837 3.22821 2.02884 1.38358 3.82716 3.08967 4.91047 4.54232 1.0833 1.45264 1.45219 2.65153 1.63645 4.15008.18426 1.49855.18426 3.29687.11509 4.26472-.0692.96785-.2075 1.10618-1.70566 1.17534-1.49816.0692-4.35703.0692-5.787-.0456-1.42996-.11478-1.42996-.34533-1.476-.82946-.046-.48413-.13827-1.2219-.25353-2.05191-.11527-.83002-.25361-1.75223-.71423-2.46716-.46063-.71492-1.24452-1.22214-2.30509-1.70648-1.06056-.48435-2.39778-.94546-3.66598-1.15319-1.26821-.20773-2.46709-.16162-4.1732-.18463-1.70612-.023-3.91944-.11524-7.83904-.0692-3.91959.0461-9.54511.23052-16.41587.50719-6.87074.27667-14.98625.64556-20.49665.94527-5.51042.29972-8.41539.53027-10.46742.73775-2.05203.20747-3.25091.39192-4.51913.71466-1.26821.32275-2.60543.78386-3.6894 1.52182-1.08397.73795-1.91396 1.75239-2.60555 2.49009-.69159.7377-1.24492 1.19881-1.89061 1.93673-.64568.73793-1.38345 1.75237-2.19037 2.74372-.80692.99134-1.68303 1.95968-2.85886 3.11243-1.17582 1.15276-2.65136 2.48997-4.8875 3.57354-2.23614 1.08356-5.23335 1.91356-7.93088 2.5822-2.69751.66864-5.09527 1.17585-7.60829 1.49869-2.51303.32284-5.14136.46117-14.31773.59953-9.17638.13836-24.90018.27669-40.62529.41503",
    id: "tube1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "beam",
    transform: "matrix(.79225 0 0 1 -22.605478 -110.573)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient6312)",
      fillOpacity: 1
    },
    id: "rect5053",
    d: "M80.653328 295.83441H592.23985v2.94391H80.653328Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.24,
      fill: "#ffd42a",
      fillOpacity: 1,
      strokeWidth: 1.22959
    },
    id: "rect5049",
    d: "M80.945892 295.06836H592.53241v4.45089H80.945892Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "laser",
    transform: "matrix(.79225 0 0 1 -22.605478 -110.573)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#ffd42a",
      stroke: "#000",
      strokeWidth: 1.12349,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "m87.624998 305.00336-22.568632.006 11.278005-15.488z",
    id: "path4004"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse4006",
    style: {
      fill: "red",
      strokeWidth: 0
    },
    d: "m70.736487 295.06909.014792.01758.014792-.01172-.029584-.00586zm7.265201 0-.029584.00586.014792.01172.014792-.01758zm-3.446471.91602-.505384.00781.004931 2.48438a2.2644367 1.687 0 0 0-.017257 0l-.42403-1.2168-.034514.00391-.093681.01367c-.03573.008-.069494.02185-.103542.03125-.04498.0113-.08816.02304-.135591.02734a1.6654925 1.0060893 24.814857 0 1-.123264.00586l.421564 1.20117-1.553131-2.25195h-.002465c-.051751.019-.103498.03578-.157778.05078-.03913.01-.068257.03078-.101077.05078a1.7418744 1.38 0 0 0-.059167.03125l1.54327 2.24024a2.2644367 1.687 0 0 0-.135591.06054l-1.141428-.96875c-.005.001-.005796.00386-.007396.00586a4.8647279 2.5799957 7.9502074 0 1-.128195.07617c-.03336.0188-.065663.03774-.103542.05274-.0011.003-.003296.00776-.007396.00976l-.034514.01954c-.01168.004-.018823.01237-.029583.01757l-.019722.01172c-.0073.005-.021334.00967-.029584.01367l-.022187.01172-.014792.00977 1.141428.96875a2.2644367 1.687 0 0 0-.157779.13672l-2.608273-1.14063a2.9283685 2.32 0 0 0-.12573.13477 1.4717576 1.166 0 0 0-.086285.13086l2.586086 1.13086a2.2644367 1.687 0 0 0-.081354.125l-1.649277-.36719v.00586c.0017.0124.0008.02326 0 .03516l-.007396.03125a.32751838.21188844 31.2475 0 1-.017257.04492c-.0053.007-.007261.01308-.009861.02148a.20893414.13517021 31.247499 0 0-.014792.04297l-.007396.03125a.44186746.28586673 31.2475 0 1-.007396.02539c.0039.00086.010061.00372.009861.01172.0017.0124-.001565.02531-.002465.03711v.01758c-.0023.0105-.009527.01342-.017257.01172v.0039c.0014.0103.001031.02241 0 .03321v.03515l1.567923.34766a2.2644367 1.687 0 0 0-.022188.12304h-3.061886v.40235h3.064351a2.2644367 1.687 0 0 0 .034514.14062l-1.59504.36133-.051771.41211 1.80952-.41016a2.2644367 1.687 0 0 0 .162709.20899l-2.886851 1.45508c.01767.02.037772.03664.056702.05664.03913.04.080171.08028.13066.11328l.081355.06445 2.872059-1.44726a2.2644367 1.687 0 0 0 .044375.0332l-1.185803.99219.229272.37304 1.358373-1.13476a2.2644367 1.687 0 0 0 .00493.00195l-1.627089 2.35742c.04292.01.082817.02316.12573.03516a1.1486273.91 0 0 1 .209549.07227l1.617228-2.3418a2.2644367 1.687 0 0 0 .103542.03125l-.530037 1.50976.532502-.04882.483197-1.37891a2.2644367 1.687 0 0 0 .04684.00195l.004931 2.41407.507849-.00977-.004931-2.4082a2.2644367 1.687 0 0 0 .120799-.01368l.488127 1.39454.532502.04882-.544828-1.55273a2.2644367 1.687 0 0 0 .118333-.03516l1.649277 2.38868a1.080467.856 0 0 1 .20955-.07227c.042913-.012.082809-.02516.125729-.03516l-1.668999-2.42187a2.2644367 1.687 0 0 0 .064098-.04102l1.343581 1.13867.500453-.14257-1.484103-1.25782a2.2644367 1.687 0 0 0 .162709-.16992l3.093935 1.35156.071494-.06835a.90880402.72 0 0 0 .118333-.12305l.049306-.06055-3.027372-1.32422 1.987021.44141-.054236-.41016-1.915528-.42578a2.2644367 1.687 0 0 0 .009861-.06445h7.999856v-.40235h-7.99246a2.2644367 1.687 0 0 0-.009861-.0664l1.900736-.43164.051771-.41016-2.088098.47461a2.2644367 1.687 0 0 0-.039445-.07031l2.859733-1.44141a1.4389397 1.14 0 0 0-.101077-.125 2.870306 2.274 0 0 0-.142986-.125l-2.817823 1.42188a2.2644367 1.687 0 0 0-.086285-.08399l1.336185-1.11914-.229271-.37695-1.464381 1.22656a2.2644367 1.687 0 0 0-.21448-.11328l1.587645-2.29883a1.7418744 1.38 0 0 0-.059167-.03125c-.03282-.02-.061947-.04078-.101077-.05078a1.7103187 1.355 0 0 1-.157778-.05078h-.002465l-1.59011 2.30664a2.2644367 1.687 0 0 0-.012327-.00391l.564551-1.61132-.532502.05078-.510314 1.45508a2.2644367 1.687 0 0 0-.106008-.01172l-.00493-2.49219zm6.301273.96289c.0088.008.018223.01658.029583.01758v-.00391a.0227201.018 0 0 0-.014791-.01172c-.0025-.001-.008561-.00295-.009861-.00195h-.004931zm-12.863867.29687c-.0025 0-.007361-.00004-.009861.00196a.02524456.02 0 0 0-.012326.01367v.00391c.0101-.002.019548-.01154.027118-.01954h-.004931zm2.541711 1.85157c.00053.00377-.00143.00763-.002465.01172l.002465-.00196c-.000703-.005.00013-.00876.002465-.00976h-.002465zm-.054236.19531v.00781a.04799839.03105262 31.247501 0 1 .002465-.00781h-.002465zm.278577 5.68555v.00195l-.022188.03125.051771-.01367a.19438308.154 0 0 1-.029583-.01953zm7.220825 0a.19438308.154 0 0 1-.029583.01953l.051771.01367-.022188-.03125v-.00195z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 0.999808,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1",
    d: "M242.43936 167.3432h24.00021v39.00019h-24.00021z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 0.999801,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1-8",
    width: 59.000248,
    height: 84.000198,
    x: 442.43951,
    y: 17.34322,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 1.00002,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1-8-5",
    width: 39.000015,
    height: 118.99998,
    x: 172.43939,
    y: 17.343311,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 1.00004,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1-8-5-5",
    width: 69.000008,
    height: 28.999954,
    x: 287.43951,
    y: 102.34334,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 0.999905,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1-8-5-5-5",
    width: 79.000153,
    height: 4.0000949,
    x: 282.43945,
    y: 97.343246,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 0.999904,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1-8-5-5-2",
    width: 14.000107,
    height: 11.000097,
    x: 314.93948,
    y: 85.343277,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 0.999963,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1-8-5-5-6",
    width: 69.000092,
    height: 29.000036,
    x: 287.43948,
    y: 242.34328,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 0.999983,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1-8-5-5-6-4",
    width: 39.000046,
    height: 34.001369,
    x: 172.43939,
    y: 237.34331,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 0.999808,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1-4",
    d: "M377.43949 167.3432h24.0002v39.00019h-24.0002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 0.999808,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-9-1-7",
    d: "M117.43927 167.3432h24.00022v39.00019h-24.00022z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rotary-pump",
    transform: "translate(18.345112 -92.349523)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3645",
    style: {
      display: "inline",
      fill: "#999",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M227.59071 418.96317v1.80664h.77344v8.23242h-13.62109v-.60156h-1.7168v11.75586h1.7168v-.73828h13.62109v19.91797h-29.17773v13.21093l-.0898.002v-8.44531s-20.07226 2.15212-20.07226 5.01953c0 1.37366-.0341 2.79685-.0684 3.92382l-.041.002s-.0131 1.16675-.0176 1.64062c-.003.0816-.0156.45508-.0156.45508h.0117c-.0229 2.36173-.0684 6.69851-.12305 8.93945-.0701 2.87581 19.57766 5.11845 20.41602 5.21289v5.70899h50.42187V459.3363h-10.1289v-19.91797h13.75v.73828h1.71679v-11.75586h-1.71679v.60156h-13.75v-8.23242h.65429v-1.80664zm-23.88867 27.66016c-.35977-.00047-.77546.002-1.26758.006-1.96847.0149-5.15856.0447-6.79882.0449-.49932.00006-.85344-.002-1.10743.0293h-6.97656v7.3379h7.24805v-.0312c.82763-.0259 2.35837.001 3.38476.0156 1.05878.0149 1.56701.0156 2.0293.0156.46229 0 .87907-.00064 1.25195.0293.37289.0299.701.0907 1.10352.4043.40252.3136.87904.87888 1.11719 1.6543.23814.77541.23828 1.76092.23828 2.74414l9.93164-.17969c.0298-.9236.0598-1.84784.0449-2.66797-.0148-.82013-.0732-1.53569-.25195-2.28125-.17877-.74556-.47738-1.52137-.93946-2.29687-.46207-.77551-1.08831-1.55196-1.78906-2.19336-.70075-.64141-1.47618-1.14674-2.32617-1.56446-.84999-.41771-1.77418-.7459-2.60938-.91015-.6264-.12319-1.2039-.15485-2.2832-.15625z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3687",
    style: {
      fill: "#4d4d4d",
      strokeWidth: 1.07682
    },
    d: "M224.12754 460.82413c-.1662 0-.29882.13458-.29882.30078v.38282c0 .1662.13262.30078.29882.30078h24.39649c.1662 0 .30078-.13458.30078-.30078v-.38282c0-.1662-.13458-.30078-.30078-.30078h-24.39649zm.03125 1.65821c-.1662 0-.30078.13458-.30078.30078v.38281c0 .1662.13458.30078.30078.30078h24.39649c.1662 0 .30078-.13458.30078-.30078v-.38281c0-.1662-.13458-.30078-.30078-.30078h-24.39649zm.06055 1.78125c-.1662 0-.29883.13458-.29883.30078v.38281c0 .1662.13263.30078.29883.30078h24.39649c.1662 0 .30078-.13458.30078-.30078v-.38281c0-.1662-.13458-.30078-.30078-.30078h-24.39649zm-.06055 1.6582c-.1662 0-.30078.13458-.30078.30078v.38281c0 .1662.13458.30078.30078.30078h24.39649c.1662 0 .30078-.13458.30078-.30078v-.38281c0-.1662-.13458-.30078-.30078-.30078h-24.39649zm-.0625 1.53711c-.1662 0-.29882.13263-.29882.29883v.38281c0 .1662.13262.30078.29882.30078h24.39844c.1662 0 .29883-.13458.29883-.30078v-.38281c0-.1662-.13263-.29883-.29883-.29883h-24.39844zm.0625 1.5957c-.1662 0-.30078.13458-.30078.30078v.38281c0 .1662.13458.29883.30078.29883h24.39649c.1662 0 .30078-.13263.30078-.29883v-.38281c0-.1662-.13458-.30078-.30078-.30078h-24.39649zm.04102 1.58984c-.1662 0-.30078.13459-.30078.30079v.38281c0 .1662.13458.30078.30078.30078h24.39648c.1662 0 .29883-.13458.29883-.30078v-.38281c0-.1662-.13263-.30079-.29883-.30079h-24.39648zm0 1.56836c-.1662 0-.30078.13459-.30078.30079v.38281c0 .1662.13458.29883.30078.29883h24.39648c.1662 0 .29883-.13263.29883-.29883v-.38281c0-.1662-.13263-.30079-.29883-.30079h-24.39648zm-.05273 1.56836c-.1662 0-.30079.13263-.30079.29883v.38281c0 .1662.13459.30079.30079.30079h24.39648c.1662 0 .30078-.13459.30078-.30079v-.38281c0-.1662-.13458-.29883-.30078-.29883h-24.39648zm0 1.56641c-.1662 0-.30079.13458-.30079.30078v.38281c0 .1662.13459.30078.30079.30078h24.39648c.1662 0 .30078-.13458.30078-.30078v-.38281c0-.1662-.13458-.30078-.30078-.30078h-24.39648zm0 1.62109c-.1662 0-.30079.13458-.30079.30078v.38086c0 .1662.13459.30079.30079.30079h24.39648c.1662 0 .30078-.13459.30078-.30079v-.38086c0-.1662-.13458-.30078-.30078-.30078h-24.39648zm.05273 1.67188c-.1662 0-.30078.13458-.30078.30078v.38281c0 .1662.13458.29883.30078.29883h24.39648c.1662 0 .29883-.13263.29883-.29883v-.38281c0-.1662-.13263-.30078-.29883-.30078h-24.39648zm0 1.51562c-.1662 0-.30078.13458-.30078.30078v.38282c0 .1662.13458.29883.30078.29883h24.39648c.1662 0 .29883-.13263.29883-.29883v-.38282c0-.1662-.13263-.30078-.29883-.30078h-24.39648zm.02539 1.67188c-.1662 0-.29883.13458-.29883.30078v.38281c0 .1662.13263.29883.29883.29883h24.39648c.1662 0 .30079-.13263.30079-.29883v-.38281c0-.1662-.13459-.30078-.30079-.30078H224.2252zm0 1.56836c-.1662 0-.29883.13263-.29883.29883v.38281c0 .1662.13263.30078.29883.30078h24.39648c.1662 0 .30079-.13458.30079-.30078v-.38281c0-.1662-.13459-.29883-.30079-.29883H224.2252zm0 1.61914c-.1662 0-.29883.13458-.29883.30078v.38281c0 .1662.13263.29883.29883.29883h24.39648c.1662 0 .30079-.13263.30079-.29883v-.38281c0-.1662-.13459-.30078-.30079-.30078H224.2252zm.05273 1.62109c-.1662 0-.30078.13263-.30078.29883v.38281c0 .1662.13458.30078.30078.30078h24.39649c.1662 0 .30078-.13458.30078-.30078v-.38281c0-.1662-.13458-.29883-.30078-.29883h-24.39649zm-.10546 1.56641c-.1662 0-.29883.13458-.29883.30078v.38281c0 .1662.13263.29883.29883.29883h24.39648c.1662 0 .30078-.13263.30078-.29883v-.38281c0-.1662-.13458-.30078-.30078-.30078h-24.39648zm.13086 1.56836c-.1662 0-.29883.13458-.29883.30078v.38281c0 .1662.13263.29883.29883.29883h24.39648c.1662 0 .30078-.13263.30078-.29883v-.38281c0-.1662-.13458-.30078-.30078-.30078h-24.39648zm0 1.61914c-.1662 0-.29883.13458-.29883.30078v.38281c0 .1662.13263.30078.29883.30078h24.39648c.1662 0 .30078-.13458.30078-.30078v-.38281c0-.1662-.13458-.30078-.30078-.30078h-24.39648zm.05273 1.62109c-.1662 0-.30078.13263-.30078.29883v.38281c0 .1662.13458.30078.30078.30078h24.39648c.1662 0 .30079-.13458.30079-.30078v-.38281c0-.1662-.13459-.29883-.30079-.29883h-24.39648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "red",
      stroke: "#000",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect3667",
    d: "M201.25661 459.32928h20.3945v35.64232h-20.3945z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3669",
    style: {
      display: "inline",
      fill: "#333",
      stroke: "#000",
      strokeWidth: 0.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M220.01426 459.80851c-.26274.00118-.52607.00863-.54492.01953-.03761.02183-.53925.8981-.53906.9414.0002.04333.50897.91405.54687.93555.03781.0213 1.05225.01594 1.08985-.00586.03762-.02183.53926-.89615.53906-.93945-.0002-.04332-.50908-.916-.54688-.9375-.0189-.01065-.28217-.01486-.54492-.01367zm-16.60351.0957c-.26275.00125-.52412.00928-.54297.02148-.03761.02435-.54121 1.00053-.54102 1.04883.0002.04833.51093 1.01907.54883 1.04297.03781.0244 1.05029.01854 1.08789-.00586.03762-.02434.54122-1.00053.54102-1.04883-.0002-.04832-.51103-1.01907-.54883-1.04296-.01891-.0122-.28218-.01688-.54492-.01563zm16.32226 15.41602c-.27412.00121-.54871.00808-.56836.01953-.03924.02289-.5627.94093-.5625.98633.0002.04543.53277.95796.57227.98046.03945.0226 1.09752.019 1.13672-.0039.03925-.02289.5627-.94093.5625-.98633-.00021-.04543-.53287-.95992-.57227-.98242-.01972-.0113-.29423-.01489-.56836-.01367zm-16.59765.08203c-.27413.00121-.54871.00808-.56836.01953-.03924.02289-.5627.94093-.5625.98633.0002.04544.53276.95797.57226.98047.03945.02259 1.09557.01899 1.13477-.00391.03925-.02289.56465-.94093.56445-.98633-.00021-.04543-.53286-.95992-.57226-.98242-.01973-.0113-.29424-.01489-.56836-.01367zm-.40821 16.84375c-.27412.00121-.54871.00808-.56836.01953-.03924.02289-.56465.94093-.56445.98633.0002.04544.53472.95797.57422.98047.03945.02259 1.09557.01704 1.13477-.00586.03925-.02289.56465-.94093.56445-.98633-.00021-.04543-.53287-.95797-.57227-.98047-.01972-.0113-.29423-.01489-.56836-.01367zm17.16993.08008c-.27413.00121-.54871.00808-.56836.01953-.03924.02289-.5627.94092-.5625.98632.0002.04544.53276.95993.57226.98243.03945.0226 1.09557.01704 1.13477-.00586.03925-.02289.56465-.94093.56445-.98633-.00021-.04543-.53287-.95797-.57227-.98047-.01972-.0113-.29423-.01684-.56835-.01562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "diffusion-pump-1",
    transform: "translate(18.041292 -92.310183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1569",
    style: {
      display: "inline",
      fill: "#333",
      stroke: "#000",
      strokeWidth: 1.80917,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M467.86263 363.85709v24.71405h-.14467c.0964 1.88.18904 3.75847.28542 5.17977.0964 1.42129.19296 2.38545.57866 3.49362.3857 1.10816 1.06273 2.36218 1.97838 3.39783.91565 1.03564 2.07208 1.85395 3.42112 2.67291 1.34903.81895 2.89167 1.63908 4.74656 2.60265 1.85489.96357 4.02112 2.07168 6.04463 3.05932 2.02352.98764 3.90356 1.85487 5.49334 3.01142 1.58977 1.15654 2.88906 2.59929 4.09361 3.75548 1.20455 1.1562 2.31178 2.02346 2.88938 3.32438.38044.85685.5229 1.8852.57475 2.74636-.008.0857-.0313.16797-.0313.25547v11.26008h-9.91147v-8.79474c0-.43117-.42611-.7792-.954-.7792h-17.34019c-.52789 0-.95009.34803-.95009.7792v23.28658c0 .43117.4222.7792.95009.7792h17.34019c.52789 0 .954-.34803.954-.7792v-4.38459h9.91147v6.77967c0 1.81163 1.78565 3.27009 4.00369 3.27009h32.20934c2.21805 0 4.00369-1.45846 4.00369-3.27009v-26.65247c.17348-.12902.16482-.32297.1564-.6323-.0236-.8667.0245-2.60146.60211-3.90238.5776-1.30092 1.68483-2.16818 2.88938-3.32438 1.20455-1.1562 2.50776-2.60214 4.09752-3.75868 1.58978-1.15655 3.46592-2.02378 5.48943-3.01141 2.02351-.98764 4.19366-2.09575 6.04854-3.05932 1.85489-.96357 3.39753-1.78052 4.74656-2.59946 1.34904-.81896 2.50547-1.64046 3.42112-2.67611.91565-1.03565 1.58878-2.28647 1.97448-3.39463.38569-1.10817.48225-2.07234.57865-3.49362.0964-1.4213.19293-3.29977.28933-5.17977h-.2776v-24.67573z",
    transform: "matrix(.49954 0 0 .6116 45.157147 141.13509)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "diffusion-pump-2",
    transform: "translate(18.041292 -92.310183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1380",
    style: {
      display: "inline",
      fill: "#333",
      stroke: "#000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M404.08524 364.39335v24.7168h-.14453c.0964 1.88.19268 3.75839.28906 5.17968.0964 1.42129.19242 2.38402.57812 3.49219.3857 1.10816 1.06092 2.36084 1.97657 3.39649.91565 1.03565 2.07283 1.85487 3.42187 2.67382 1.34903.81895 2.88925 1.638 4.74414 2.60157 1.85489.96357 4.02337 2.07291 6.04688 3.06054 2.02351.98764 3.90241 1.85322 5.49218 3.00977 1.58977 1.15654 2.89116 2.60357 4.09571 3.75977 1.20455 1.15619 2.31302 2.0233 2.89062 3.32421.31995.72061.46818 1.56267.54102 2.32813v11.92969h-9.58789v-9.09571c0-.2637-.21286-.47461-.47657-.47461h-9.26562c-.2637 0-.47656.21091-.47656.47461v23.89258c0 .26371.21286.47656.47656.47656h9.26562c.26371 0 .47657-.21285.47657-.47656v-4.68555h9.58789v8.04883c0 1.108.892 2 2 2h36.21679c1.108 0 2-.892 2-2v-27.91601c.18088-.12887.16479-.32724.15625-.64063-.0236-.8667.0259-2.60142.60352-3.90234.5776-1.30092 1.68608-2.16802 2.89063-3.32422 1.20454-1.1562 2.50398-2.60127 4.09375-3.75781 1.58977-1.15655 3.46866-2.02408 5.49218-3.01172 2.02351-.98764 4.19199-2.09503 6.04688-3.0586 1.85489-.96356 3.39706-1.78261 4.74609-2.60156 1.34904-.81896 2.50427-1.63818 3.41992-2.67383.91565-1.03564 1.59087-2.28832 1.97657-3.39648.3857-1.10817.48172-2.0709.57812-3.49219.0964-1.4213.19266-3.30164.28906-5.18164h-.27734v-24.67578z",
    transform: "translate(.03455891 -.51835043)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "detection-chamber",
    style: {
      display: "inline"
    },
    transform: "translate(18.041292 -92.310183)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 0.999901,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-0",
    d: "M124.39795 229.65344h99.0001v99.0001h-99.0001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15021",
    style: {
      display: "inline",
      opacity: 1,
      fill: "gray",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "m-99.687134-5.0978063-5.831716.0976125-2.82826 5.0983733 2.99845 5.0007609 5.831722-.1001154 2.828258-5.0958704-2.998454-5.0007609zm102.5181011 0-5.8317181.0976125L-5.8290092.0981795l2.9984543 5.0007609 5.8317181-.1001154L5.8294213-.0970454 2.8309671-5.0978063zM-99.687134 97.420295l-5.831716.097612-2.82826 5.098373 2.99845 5.00076 5.831722-.10011 2.828258-5.09587-2.998454-5.000765zm102.5181011 0-5.8317181.097612-2.8282582 5.098373 2.9984543 5.00076 5.8317181-.10011 2.8282581-5.09587-2.9984542-5.000765z",
    transform: "translate(213.898 239.15349) scale(.78035)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "doping-chamber",
    style: {
      display: "inline"
    },
    transform: "translate(18.041292 -92.310183)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 1.00001,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9",
    d: "M249.39799 224.65349H358.398v108.99999H249.39799Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15021-1",
    style: {
      display: "inline",
      fill: "gray",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "m2.8309671-120.43067-5.8317181.09761-2.8282582 5.09838 2.9984543 5.00076 5.8317181-.10012 2.8282581-5.09587-2.9984542-5.00076zm115.3328629 0-5.83172.09761-2.82826 5.09838 2.99846 5.00076 5.83172-.10012 2.82825-5.09587-2.99845-5.00076zM2.8309671-5.0978063l-5.8317181.0976125L-5.8290092.0981795l2.9984543 5.0007609 5.8317181-.1001154L5.8294213-.0970454 2.8309671-5.0978063zm115.3328629 0-5.83172.0976125-2.82826 5.0983733 2.99846 5.0007609 5.83172-.1001154 2.82825-5.0958704-2.99845-5.0007609z",
    transform: "translate(258.898 324.15349) scale(.78035)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "source-chamber",
    style: {
      display: "inline"
    },
    transform: "translate(18.041292 -92.310183)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#999",
      stroke: "#000",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect274-3-9-7",
    d: "M384.39807 194.65355h138.99988v168.99988H384.39807Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15021-17",
    style: {
      display: "inline",
      fill: "gray",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.78035,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "m396.10715 200.17542-4.55079.07617-2.20703 3.97851 2.33985 3.90235 4.55078-.07813 2.20703-3.97656-2.33984-3.90234zm120 0-4.55079.07617-2.20703 3.97851 2.33985 3.90235 4.55078-.07813 2.20703-3.97656-2.33984-3.90234zm-120 150-4.55079.07617-2.20703 3.97851 2.33985 3.90235 4.55078-.07813 2.20703-3.97656-2.33984-3.90234zm120 0-4.55079.07617-2.20703 3.97851 2.33985 3.90235 4.55078-.07813 2.20703-3.97656-2.33984-3.90234z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ion-gauge-3",
    style: {
      display: "inline"
    },
    transform: "translate(283.0567 -127.5205)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999",
      fillOpacity: 1,
      stroke: "#000",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect445",
    d: "M133.93692 218.85104h10.07635v10.24154h-10.07635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#333",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect447",
    d: "M128.65096 189.15913h20.48308v29.6919h-20.48308z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect451",
    style: {
      fill: "#ffd42a",
      strokeWidth: 0.884725
    },
    d: "M128.95502 189.13183c-.1662 0-.30078.13263-.30078.29883v28.99218c0 .1662.13458.30078.30078.30078h3.35937c.1662 0 .30078-.13458.30078-.30078v-28.99218c0-.1662-.13458-.29883-.30078-.29883h-3.35937zm16.51172 0c-.1662 0-.29883.13263-.29883.29883v29.05664c0 .1662.13263.30078.29883.30078h3.44922c.1662 0 .29882-.13458.29882-.30078v-29.05664c0-.1662-.13262-.29883-.29882-.29883h-3.44922zm-10.86719 15.66406c-.1662 0-.29883.13458-.29883.30078v3.30664c0 .1662.13263.30078.29883.30078h3.63867c.1662 0 .30078-.13458.30078-.30078v-3.30664c0-.1662-.13458-.30078-.30078-.30078h-3.63867zm4.96875.0332c-.1662 0-.30078.13458-.30078.30078v3.30665c0 .16619.13458.30078.30078.30078h3.63867c.1662 0 .29883-.13459.29883-.30078v-3.30665c0-.1662-.13263-.30078-.29883-.30078h-3.63867zm-5.03516 4.76953c-.1662 0-.29882.13263-.29882.29883v3.3086c0 .1662.13262.30078.29882.30078h3.63868c.1662 0 .30078-.13458.30078-.30078v-3.3086c0-.1662-.13458-.29883-.30078-.29883h-3.63868zm5.09961 0c-.1662 0-.29883.13263-.29883.29883v3.3086c0 .1662.13263.30078.29883.30078h3.63867c.1662 0 .30079-.13458.30079-.30078v-3.3086c0-.1662-.13459-.29883-.30079-.29883h-3.63867z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000"
    },
    id: "rect463",
    width: 8.742321,
    height: 9.4046173,
    x: 134.49886,
    y: 191.55077,
    rx: 0.30000001,
    ry: 0.30000001
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#000"
    },
    id: "path465",
    d: "m76.154502 210.04994-1.171932-.74241 1.228914-.64372z",
    transform: "translate(64.844561 -1.4086983)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000"
    },
    id: "path467",
    d: "M74.566543 206.06313c.294473-1.06746 1.43273-1.7135 2.500193-1.41903 1.067463.29448 1.7135 1.43273 1.419028 2.5002-.294473 1.06746-1.432729 1.7135-2.500193 1.41902",
    transform: "matrix(.7099 0 0 .61717 87.016129 79.259272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect469",
    style: {
      display: "inline",
      fill: "#000"
    },
    d: "M142.52338 210.23925c-.1662 0-.29883.13458-.29883.30078v1.14063h-1.41992c-.04089 0-.07782.00874-.11328.02343l-.00196-.33398-1.17187.81641 1.18164.79687-.00195-.35352c.03389.01322.06874.02149.10742.02149h1.89453c.12841 0 .23829-.08038.28125-.19336.02999-.04672.04687-.10224.04687-.16211v-1.75586c0-.1662-.13262-.30078-.29882-.30078h-.20508z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path475",
    style: {
      display: "inline",
      fill: "#000"
    },
    d: "m136.3808 205.05956-1.04688 1.83399.58399-.00196c-.02252.04215-.03516.09127-.03516.14258v1.06445c0 .1662.13458.29883.30078.29883h.40821c.1662 0 .29883-.13263.29883-.29883v-1.06445c0-.05293-.01324-.1034-.03711-.14648l.59375-.00196-1.06641-1.82617z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path481",
    style: {
      display: "inline",
      fill: "#000"
    },
    d: "M136.13275 209.90136c-.1662 0-.30078.13458-.30078.30078v1.06445c0 .05194.01407.10007.03711.14258l-.58594-.00195 1.04883 1.83398 1.06445-1.82617-.59375-.00195c.02436-.04341.03907-.09298.03907-.14649v-1.06445c0-.1662-.13458-.30078-.30078-.30078h-.40821z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ion-gauge-2",
    style: {
      display: "inline"
    },
    transform: "translate(133.53541 -97.269378)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999",
      fillOpacity: 1,
      stroke: "#000",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect716",
    d: "M133.93692 218.85104h10.07635v10.24154h-10.07635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#333",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect718",
    d: "M128.65096 189.15913h20.48308v29.6919h-20.48308z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect722",
    style: {
      fill: "#ffd42a",
      strokeWidth: 0.884725
    },
    d: "M128.95482 189.13071c-.1662 0-.30078.13458-.30078.30078v28.99218c0 .1662.13458.29883.30078.29883h3.36133c.1662 0 .29883-.13263.29883-.29883v-28.99218c0-.1662-.13263-.30078-.29883-.30078h-3.36133zm16.51172 0c-.1662 0-.29883.13458-.29883.30078v29.05664c0 .1662.13263.29883.29883.29883h3.44922c.1662 0 .29883-.13263.29883-.29883v-29.05664c0-.1662-.13263-.30078-.29883-.30078h-3.44922zm-10.86718 15.66601c-.1662 0-.29883.13458-.29883.30078v3.30664c0 .1662.13263.30078.29883.30078h3.63867c.1662 0 .30078-.13458.30078-.30078v-3.30664c0-.1662-.13458-.30078-.30078-.30078h-3.63867zm4.96875.0332c-.1662 0-.30079.13459-.30079.30079v3.30664c0 .1662.13459.30078.30079.30078h3.63867c.1662 0 .29883-.13458.29883-.30078v-3.30664c0-.1662-.13263-.30079-.29883-.30079h-3.63867zm-5.03321 4.76758c-.1662 0-.30078.13458-.30078.30078v3.3086c0 .1662.13458.29883.30078.29883h3.63867c.1662 0 .29883-.13263.29883-.29883v-3.3086c0-.1662-.13263-.30078-.29883-.30078h-3.63867zm5.09961 0c-.1662 0-.30078.13458-.30078.30078v3.3086c0 .1662.13458.29883.30078.29883h3.63867c.1662 0 .29883-.13263.29883-.29883v-3.3086c0-.1662-.13263-.30078-.29883-.30078h-3.63867z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000"
    },
    id: "rect734",
    width: 8.742321,
    height: 9.4046173,
    x: 134.49886,
    y: 191.55077,
    rx: 0.30000001,
    ry: 0.30000001
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#000"
    },
    id: "path736",
    d: "m76.154502 210.04994-1.171932-.74241 1.228914-.64372z",
    transform: "translate(64.844561 -1.4086983)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000"
    },
    id: "path738",
    d: "M74.566543 206.06313c.294473-1.06746 1.43273-1.7135 2.500193-1.41903 1.067463.29448 1.7135 1.43273 1.419028 2.5002-.294473 1.06746-1.432729 1.7135-2.500193 1.41902",
    transform: "matrix(.7099 0 0 .61717 87.016129 79.259272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect740",
    style: {
      display: "inline",
      fill: "#000"
    },
    d: "M142.52318 210.24008c-.1662 0-.29882.13458-.29882.30078v1.14063h-1.41797c-.04 0-.07845.0074-.11328.02148l-.00196-.33203-1.17383.81445 1.18164.79883-.00195-.35351c.0339.01321.07069.02148.10938.02148h1.89453c.12841 0 .23633-.08038.27929-.19336.02999-.04672.04688-.10224.04688-.16211v-1.75586c0-.1662-.13263-.30078-.29883-.30078h-.20508z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path746",
    style: {
      display: "inline",
      fill: "#000"
    },
    d: "m136.38256 205.05844-1.04883 1.83594.58594-.00196c-.02253.04216-.03711.08931-.03711.14063v1.06445c0 .1662.13458.30078.30078.30078h.4082c.1662 0 .30078-.13458.30078-.30078v-1.06445c0-.05345-.01475-.10311-.03906-.14648l.59375-.00196-1.06445-1.82617z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path752",
    style: {
      display: "inline",
      fill: "#000"
    },
    d: "M136.13256 209.90219c-.1662 0-.30078.13458-.30078.30078v1.06445c0 .05132.01458.09847.03711.14063l-.58594-.00195 1.04883 1.83593 1.06445-1.82617-.59375-.00195c.02436-.04341.03906-.09298.03906-.14649v-1.06445c0-.1662-.13458-.30078-.30078-.30078h-.4082z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ion-gauge-1",
    style: {
      display: "inline"
    },
    transform: "translate(17.879312 -92.380823)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999",
      fillOpacity: 1,
      stroke: "#000",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect766",
    d: "M133.93692 218.85104h10.07635v10.24154h-10.07635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#333",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "rect768",
    d: "M128.65096 189.15913h20.48308v29.6919h-20.48308z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect772",
    style: {
      fill: "#ffd42a",
      strokeWidth: 0.884725
    },
    d: "M128.95467 189.13082c-.1662 0-.30078.13458-.30078.30078v28.99219c0 .1662.13458.29883.30078.29883h3.36133c.1662 0 .29883-.13263.29883-.29883V189.4316c0-.1662-.13263-.30078-.29883-.30078h-3.36133zm16.51172 0c-.1662 0-.29883.13458-.29883.30078v29.05664c0 .1662.13263.29883.29883.29883h3.44922c.1662 0 .29883-.13263.29883-.29883V189.4316c0-.1662-.13263-.30078-.29883-.30078h-3.44922zm-10.86719 15.66602c-.1662 0-.29882.13458-.29882.30078v3.30664c0 .1662.13262.30078.29882.30078h3.64063c.1662 0 .29883-.13458.29883-.30078v-3.30664c0-.1662-.13263-.30078-.29883-.30078h-3.64063zm4.96875.0332c-.1662 0-.30078.13263-.30078.29883v3.30859c0 .1662.13458.30078.30078.30078h3.63868c.1662 0 .29882-.13458.29882-.30078v-3.30859c0-.1662-.13262-.29883-.29882-.29883h-3.63868zm-5.0332 4.76758c-.1662 0-.30078.13458-.30078.30078v3.30664c0 .1662.13458.30078.30078.30078h3.63867c.1662 0 .29883-.13458.29883-.30078v-3.30664c0-.1662-.13263-.30078-.29883-.30078h-3.63867zm5.09961 0c-.1662 0-.30078.13458-.30078.30078v3.30664c0 .1662.13458.30078.30078.30078h3.63867c.1662 0 .29883-.13458.29883-.30078v-3.30664c0-.1662-.13263-.30078-.29883-.30078h-3.63867z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000"
    },
    id: "rect784",
    width: 8.742321,
    height: 9.4046173,
    x: 134.49886,
    y: 191.55077,
    rx: 0.30000001,
    ry: 0.30000001
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#000"
    },
    id: "path786",
    d: "m76.154502 210.04994-1.171932-.74241 1.228914-.64372z",
    transform: "translate(64.844561 -1.4086983)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000"
    },
    id: "path788",
    d: "M74.566543 206.06313c.294473-1.06746 1.43273-1.7135 2.500193-1.41903 1.067463.29448 1.7135 1.43273 1.419028 2.5002-.294473 1.06746-1.432729 1.7135-2.500193 1.41902",
    transform: "matrix(.7099 0 0 .61717 87.016129 79.259272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect790",
    style: {
      display: "inline",
      fill: "#000"
    },
    d: "M142.52303 210.2402c-.1662 0-.29883.13458-.29883.30078v1.14062h-1.41797c-.03999 0-.07844.0074-.11328.02149l-.00195-.33203-1.17187.81445 1.17968.79883-.00195-.35352c.03377.01311.07087.02149.10937.02149h1.89454c.12841 0 .23633-.08039.27929-.19336.02999-.04673.04688-.10224.04688-.16211v-1.75586c0-.1662-.13263-.30078-.29883-.30078h-.20508z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path796",
    style: {
      display: "inline",
      fill: "#000"
    },
    d: "m136.38241 205.05856-1.04883 1.83593.58594-.00195c-.02253.04216-.03711.08931-.03711.14063v1.06445c0 .1662.13458.30078.30078.30078h.4082c.1662 0 .30078-.13458.30078-.30078v-1.06445c0-.05351-.01471-.10308-.03906-.14649l.59375-.00195-1.06445-1.82617z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path802",
    style: {
      display: "inline",
      fill: "#000"
    },
    d: "M136.13241 209.90231c-.1662 0-.30078.13458-.30078.30078v1.06445c0 .05132.01458.09847.0371.14063l-.58593-.00196 1.04883 1.83594 1.06445-1.82617-.59375-.00195c.02435-.04341.03906-.09298.03906-.14649v-1.06445c0-.1662-.13458-.30078-.30078-.30078h-.4082z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "turbo-pump",
    transform: "translate(18.041292 -92.310183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2080",
    style: {
      fill: "#333",
      stroke: "#000",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M143.63594 364.25983v19.9336h-13.75v-.98633h-3.31641v12.51172h3.31641v-.94532h13.75v4.29493h59.95508v-34.8086z",
    transform: "translate(.36210735 -.26764479)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lecture",
    transform: "translate(18.041292 -92.310183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1303",
    style: {
      fill: "#4d4d4d",
      strokeWidth: 0.694687
    },
    d: "m32.542692 374.12659-7.820312 2.98047 3.162109 4.69922 1.458984-.01172v4.7207h-4.511718v3.27344h4.511718v10.29883h6.890625V389.7887h4.38086v-3.27344h-4.38086v-4.77344l1.423828-.01172 2.88086-4.74609-7.996094-2.85742z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path836",
    style: {
      fill: "maroon",
      strokeWidth: 0.697593
    },
    d: "M32.540739 397.27503a14.601511 13.927815 0 0 0-14.541016 13.10742h-.060547v59.71484a15.57327 4.2389007 0 0 0-.951171 1.44922 15.57327 4.2389007 0 0 0 15.574218 4.24023 15.57327 4.2389007 0 0 0 15.572266-4.24023 15.57327 4.2389007 0 0 0-.970703-1.4707v-59.69336h-.048828a14.601511 13.927815 0 0 0-14.574219-13.10742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666",
      strokeWidth: 0.999996
    },
    id: "rect1697",
    d: "M19.780813 413.44748h25.617868v57.02042H19.780813Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "salt",
    transform: "matrix(-.0001 -.36268 .61381 -.00006 68.865548 200.88714)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path25788",
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#linearGradient29460)",
      fillOpacity: 1,
      strokeWidth: 0.315818,
      strokeDasharray: ".157909,.157909"
    },
    d: "M30.686168 39.290212a13.190802 5.419284 30.6369 0 0-3.357945 1.526316 13.190802 5.419284 30.6369 0 0 8.801815 11.414825 13.190802 5.419284 30.6369 0 0 13.979048 1.885248 13.190802 5.419284 30.6369 0 0-8.801812-11.414826 13.190802 5.419284 30.6369 0 0-10.621106-3.411563z",
    transform: "translate(.00000138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30437",
    style: {
      display: "inline",
      fill: "url(#linearGradient30439)",
      fillOpacity: 1,
      strokeWidth: 1.0594
    },
    d: "M41.06571 30.07465c.07731.01258.154797.02438.232027.03728.2035.03565.406599.07341.609265.112944-.0054-.02029-.0091-.04006-.01137-.05976a14.241977 6.5931061 0 0 0-.829922-.090464Zm-15.109155 8.263584c-.0132.0076-.02444.01819-.03669.02741-.06396.04521-.129242.09019-.201022.119523-.164993.08362-.133698.06784-.115238.05866v.000548c.01654-.0083.03414-.01675.03927-.01919-.0051.0028-.01758.0094-.04082.02138.000765-.001.000882-.0013.0016-.0022-.01001.005-.0175.0088-.02739.01371H25.5757c-.06022.0538-.170868.162772-.09767.07676-.08512.07599-.191303.138628-.194303.139261-.07464.05549-.112676.0831-.135909.09978-.09903.09401-.204449.176611-.318844.248916-.03903.02257-.104789.07888-.137459.1113-.0085.007-.01495.01217-.0217.01755-.01127.01553-.03224.04167-.07028.08499-.03938.04398-.07725.08915-.114205.135423-.01291.01446-.02485.02995-.03876.04331-.0053.0051-.0087.0082-.01344.01262-.0013.0017-.0018.0027-.0031.0043-.01228.01794-.0376.05552-.04961.07128-.0012.0016-.0037.0051-.0052.0071-.0057.01212-.0125.02338-.02015.03126-.03203.05473-.06049.09124-.0832.121168-.04435.09207-.115143.232344-.125057.234113-.0091.01405-.01826.02815-.02739.04222v31.327276h.08785a14.241977 6.5931061 0 0 0-.08785.676021 14.241977 6.5931061 0 0 0 14.242024 6.594638 14.241977 6.5931061 0 0 0 14.242025-6.594638 14.241977 6.5931061 0 0 0-.08992-.676021h.08992V55.385715c-.195011-.133176-.391351-.269646-.574642-.417785.06888.02535.04109.01102-.112655-.08718-.02925-.01662-.05901-.03291-.08837-.04935-.203983-.126404-.334617-.212202-.61495-.407367-.149092-.0985-.287379-.21068-.445968-.292779-.234757-.130173-.468169-.262754-.7059-.387081-.28897-.160085-.584063-.309635-.864546-.485771-.229737-.131372-.460734-.258132-.691431-.386529-.192729-.117948-.398061-.212743-.595312-.321837-.358028-.171267-.715262-.342907-1.066085-.530181-.33141-.198816-.669594-.386203-.991154-.602553-.339323-.20688-.690524-.389947-1.026294-.603649-.292815-.196496-.59996-.369208-.894002-.564175-.328778-.208881-.653514-.424253-.979747-.637636-.31493-.242879-.642526-.466449-.961698-.702887-.228722-.166543-.454401-.335816-.688847-.492898-.217562-.166063-.440431-.323914-.665592-.478095-.124264-.107411-.269032-.18441-.406177-.270847-.134768-.072757-.394389-.207365-.625285-.355282-.208275-.100494-.390627-.259419-.587044-.381598-.288005-.186381-.573594-.375199-.859896-.564722-.23605-.15331-.476357-.299275-.713135-.45123-.281855-.186778-.554941-.385768-.822172-.595425-.178248-.135513-.341346-.289467-.539502-.394758-.253221-.177445-.504466-.357807-.751375-.544984-.245871-.180575-.497593-.352411-.745691-.529633-.361657-.235676-.713322-.488921-1.078487-.718787-.453473-.303376-.908407-.603921-1.361157-.908489-.538595-.346492-1.089871-.670512-1.623157-1.026369-.608489-.407249-1.216926-.815607-1.855701-1.168372-.610997-.345299-1.200384-.728892-1.800406-1.094903-.28808-.191434-.572644-.388709-.855762-.588298-.03045.0138-.05565.02128-.06925.01644-.0028.000312-.006.000784-.0088.0011.0066-.0034.01355-.007.02015-.0104.0478-.03813-.03191.02024-.0186.0055.0065-.0072.0299-.02342.0217-.01864zm-.380339.219858c-.0083.0041.0318-.01645.02739-.01426.01718-.02371.000086-.01029-.02739.01426z",
    transform: "translate(.00000138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31294-69",
    style: {
      display: "inline",
      fill: "url(#linearGradient31318-32)",
      fillOpacity: 1,
      strokeWidth: 0.498473
    },
    d: "M38.89195 71.880245a22.718232.91505818 0 0 0-22.577726.82114H16.1741v4.92716h.140124a22.718232.91505818 0 0 0-.140124.0938 22.718232.91505818 0 0 0 22.717994.91532 22.718232.91505818 0 0 0 22.717984-.91532 22.718232.91505818 0 0 0-.142995-.0938h.142995v-4.92716h-.142995a22.718232.91505818 0 0 0-22.575082-.82114zm-23.064739.91496.346753 4.97446z",
    transform: "translate(.00000138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24268",
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#linearGradient29444)",
      fillOpacity: 1,
      strokeWidth: 0.384162,
      strokeDasharray: ".19208,.19208"
    },
    transform: "matrix(.86395 .50358 -.47798 .87837 .00000138 -4.9e-7)",
    d: "M43.01171 17.951257a16.046764 6.5913706 0 0 0-2.704668 3.662092 16.046764 6.5913706 0 0 0 16.04673 6.591364 16.046764 6.5913706 0 0 0 16.046925-6.591825 16.046764 6.5913706 0 0 0-16.04673-6.591365 16.046764 6.5913706 0 0 0-13.342257 2.929734z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25060",
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#linearGradient28702)",
      fillOpacity: 1,
      strokeWidth: 0.349992,
      strokeDasharray: ".174997,.174997"
    },
    d: "M29.346583 38.255397a14.663122 5.9872414 30.194104 0 0-3.744839 1.680834 14.663122 5.9872414 30.194104 0 0 9.815936 12.570423 14.663122 5.9872414 30.194104 0 0 15.589678 2.076104 14.663122 5.9872414 30.194104 0 0-9.815933-12.570424 14.663122 5.9872414 30.194104 0 0-11.844842-3.756937Z",
    transform: "translate(.00000138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27968",
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#linearGradient29476)",
      fillOpacity: 1,
      strokeWidth: 0.283433,
      strokeDasharray: ".141717,.141717"
    },
    d: "M31.469269 40.117948a11.870565 4.8503169 30.2427 0 0-3.030574 1.36214 11.870565 4.8503169 30.2427 0 0 7.943712 10.187002 11.870565 4.8503169 30.2427 0 0 12.616209 1.682464 11.870565 4.8503169 30.2427 0 0-7.94371-10.187004 11.870565 4.8503169 30.2427 0 0-9.585637-3.044602z",
    transform: "translate(.00000138)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHendiExterior);
export default __webpack_public_path__ + "static/media/hendi-exterior.486185e875be3023960ffcd2dbfca3b8.svg";
export { ForwardRef as ReactComponent };